__turbopack_context__.v({
  "containerCenter": "styles-module__Mfcg3W__containerCenter" + " " + "styles-module__Mfcg3W__containerLeft",
  "containerLeft": "styles-module__Mfcg3W__containerLeft",
  "imageContainer": "styles-module__Mfcg3W__imageContainer",
});
